import { render, staticRenderFns } from "./AdminNotifications.vue?vue&type=template&id=67a643a2&lang=pug"
import script from "./AdminNotifications.vue?vue&type=script&lang=js"
export * from "./AdminNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports